import { render, staticRenderFns } from "./RegisteredAccountControl.vue?vue&type=template&id=3d810c7d&scoped=true&"
import script from "./RegisteredAccountControl.vue?vue&type=script&lang=js&"
export * from "./RegisteredAccountControl.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredAccountControl.vue?vue&type=style&index=0&id=3d810c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d810c7d",
  null
  
)

export default component.exports